<template>
  <div id="app">
    <Login v-if="!token" />
    <ShuifaData v-if="token"/>
  </div>
</template>

<script>
import ShuifaData from './components/shuifa/index.vue'
import Login from './components/login/index.vue'
export default {
  name: 'app',
  components: {
    ShuifaData,
    Login
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  mounted() {
    let value = localStorage.getItem('app-token');
    if (value) {
      this.$store.dispatch("changeDispatch", value);
    }
    let userInfo = localStorage.getItem('app-user-info');
    if (userInfo) {
      if (typeof userInfo == 'string') {
        userInfo = JSON.parse(userInfo);
      }
      this.$store.dispatch("doChangeUserInfo", userInfo);
    }
    let isLoop = localStorage.getItem('app-loop');
    if (isLoop) {
      this.$store.dispatch("doChangeLoop", true);
    } else {
      this.$store.dispatch("doChangeLoop", false);
    }
  }
}
</script>

<style>
#app {
  font-family: 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

@charset "utf-8";

* {
  word-wrap: break-word;
  outline: none;
  box-sizing: border-box;
}

body {
  background: #0b1120;
  margin: 0;
}

html {
  -webkit-text-size-adjust: none;
}

body,
td,
input,
textarea,
select,
button {
  color: #cbd5e1;
  font-size: 13px;
  font-family: 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

body,
ul,
ol,
li,
dl,
dt,
dd,
p,
h1,
h2,
h3,
h4,
h5,
h6,
form,
fieldset {
  margin: 0;
  padding: 0;
}

ul,
ol,
li {
  list-style-image: none;
  list-style-type: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 12px;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

a {
  color: #3b82f6;
  text-decoration: none;
}

a:hover {
  color: #60a5fa;
  text-decoration: none;
}

a img {
  border: none;
}

em,
cite,
th {
  font-style: normal;
  font-weight: normal;
}

table {
  border-collapse: collapse;
  word-break: break-all;
  word-wrap: break-word;
}

th {
  text-align: left;
}

input,
button,
select,
textarea {
  outline: none;
  margin: 0px;
  padding: 0px;
}

header,
section,
div {
  box-sizing: border-box;
  margin: 0px;
  padding: 0px;
}

.clear {
  clear: both;
}

/* Scrollbar styling */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: #334155;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #475569;
}

/* SweetAlert2 custom */
.swal2-title {
  font-size: 18px !important;
  padding-top: 0 !important;
  color: #e2e8f0 !important;
}

.swal2-icon {
  width: 50px !important;
  height: 50px !important;
  margin-top: 20px !important;
}

.swal2-html-container {
  font-size: 12px !important;
  margin-top: 7px !important;
  color: #94a3b8 !important;
}

.swal2-popup {
  background: #1e293b !important;
  border: 1px solid #334155 !important;
  border-radius: 12px !important;
}

.swal2-confirm {
  background-color: #3b82f6 !important;
  border-radius: 6px !important;
}

.swal2-cancel {
  background-color: #475569 !important;
  border-radius: 6px !important;
}
</style>
